
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/2021-csr",
      function () {
        return require("private-next-pages/doc/2021-csr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doc/2021-csr"])
      });
    }
  